export default "__VITE_ASSET__639d1a09__"